import React from 'react';
import CaretDownIcon from './CustomIcons/CaretDownIcon';
import CaretUpIcon from './CustomIcons/CaretUpIcon';
import { FOCUS_RING } from './focusRing';

export interface SidePanelNavFooterProps {
    onNavigateUp?: () => void;
    onNavigateDown?: () => void;
    canNavigateUp?: boolean;
    canNavigateDown?: boolean;
    actions?: React.ReactNode;
    className?: string;
}

const KEYCAP =
    'flex h-[20px] min-w-[20px] items-center justify-center rounded-lg border border-solid border-[var(--malachite-card-border)] bg-[var(--malachite-card-background)] px-[4px] [box-shadow:0_1px_0_0_rgba(0,0,0,0.15)]';
const LABEL = 'text-[13px] font-medium tracking-[0.14px] text-[var(--malachite-text-secondary)]';

const NavKey: React.FC<{
    onClick?: () => void;
    disabled?: boolean;
    ariaLabel: string;
    children: React.ReactNode;
}> = ({ onClick, disabled, ariaLabel, children }) => (
    <button
        type="button"
        aria-label={ariaLabel}
        onClick={onClick}
        disabled={disabled}
        className={`${KEYCAP} transition-opacity ${FOCUS_RING} ${
            disabled
                ? 'cursor-not-allowed opacity-40'
                : 'cursor-pointer hover:border-[var(--malachite-text-placeholder)]'
        }`}
    >
        {children}
    </button>
);

const SidePanelNavFooter: React.FC<SidePanelNavFooterProps> = ({
    onNavigateUp,
    onNavigateDown,
    canNavigateUp = false,
    canNavigateDown = false,
    actions,
    className = '',
}) => (
    <div className={`flex w-full items-center justify-between ${className}`}>
        <div className="flex items-center gap-[8px]">
            <div className="flex items-center gap-[4px]">
                <NavKey ariaLabel="Previous" onClick={onNavigateUp} disabled={!canNavigateUp}>
                    <CaretUpIcon size={11} />
                </NavKey>
                <NavKey ariaLabel="Next" onClick={onNavigateDown} disabled={!canNavigateDown}>
                    <CaretDownIcon size={11} />
                </NavKey>
            </div>
            <span className={LABEL}>Navigate</span>
            <div className="ml-[20px] flex items-center gap-[8px]">
                <span
                    className={`${KEYCAP} px-[6px] text-[10px] font-medium uppercase tracking-[0.5px] text-[var(--malachite-text-placeholder)]`}
                >
                    esc
                </span>
                <span className={LABEL}>Close</span>
            </div>
        </div>
        {actions ? <div className="flex items-center">{actions}</div> : null}
    </div>
);

export default SidePanelNavFooter;
export { SidePanelNavFooter };
